import templateUrl from "emun.invoice/credit-request/credit-request-list.htm";

export default () => ({
  templateUrl
});
